module.exports = __webpack_public_path__ + "media/images/manifest/microbius-128-b74c87c971e9fa614a95151f42b53634.png";